import { createRouter, createWebHistory } from "vue-router";

import Home from "@/views/home.vue";
import Services from "@/views/servises.vue";
import ProjectDetails from "@/views/ProjectDetails.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "SpeDev — Développement Web & Mobile, IA, Cloud, E-commerce",
      description:
        "SpeDev développe des applications web/mobile, des APIs métier, des tableaux de bord data temps réel, des solutions e-commerce et DevOps.",
      canonical: "https://dev.spe-store-sarl.com/",
    },
  },
  {
    path: "/projects",
    name: "Projects",
    component: () => import('@/views/Projects.vue'),
    meta: {
      title: "Nos projets — Réalisations SpeDev",
      description:
        "Parcourez des projets concrets : apps mobiles, B2B interne, analytics data, e-commerce, cybersécurité, IoT, IA générative.",
      canonical: "https://dev.spe-store-sarl.com/projects",
    },
  },
  {
    path: "/services",
    name: "Services",
    component: Services,
    meta: {
      title: "Services — Web & Mobile, IA & Data, Cloud, Sécurité",
      description:
        "Développement web & mobile, IA & Data, e-commerce & paiements, DevOps & Cloud, cybersécurité, IoT et formation technique.",
      canonical: "https://dev.spe-store-sarl.com/services",
    },
  },
  {
    path: "/projects/:slug",
    name: "ProjectDetails",
    component: ProjectDetails,
    props: true,
    meta: {
      title: (to) => `Projet ${to.params.slug} — SpeDev`,
      description: (to) =>
        `Détails du projet ${to.params.slug} : objectifs, fonctionnalités, stack technique et valeur ajoutée.`,
      canonical: (to) =>
        `https://dev.spe-store-sarl.com/projects/${to.params.slug}`,
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// router.js
import { projects } from "@/data/projectsData.js";

router.beforeEach((to, from, next) => {
  const base = "SpeDev — Développement Web & Mobile, IA, Cloud, E-commerce";
  const defaultDesc =
    "SpeDev crée des solutions web, mobiles, IA et e-commerce performantes.";

  let title = base;
  let description = defaultDesc;
  let canonical = "https://dev.spe-store-sarl.com/";

  if (to.meta.title) {
    title =
      typeof to.meta.title === "function" ? to.meta.title(to) : to.meta.title;
  }
  if (to.meta.description) {
    description =
      typeof to.meta.description === "function"
        ? to.meta.description(to)
        : to.meta.description;
  }
  if (to.meta.canonical) {
    canonical =
      typeof to.meta.canonical === "function"
        ? to.meta.canonical(to)
        : to.meta.canonical;
  }

  // ✅ Cas des projets individuels
  if (to.name === "ProjectDetails" && to.params.slug) {
    const project = projects.find((p) => p.slug === to.params.slug);
    if (project) {
      title = `${project.title} — Réalisé par SpeDev`;
      description = project.description || description;
      canonical = `https://dev.spe-store-sarl.com/projects/${project.slug}`;
    }
  }

  document.title = title;

  // Met à jour <meta name="description">
  let descTag = document.querySelector('meta[name="description"]');
  if (!descTag) {
    descTag = document.createElement("meta");
    descTag.setAttribute("name", "description");
    document.head.appendChild(descTag);
  }
  descTag.setAttribute("content", description);

  // Met à jour <link rel="canonical">
  let canonTag = document.querySelector('link[rel="canonical"]');
  if (!canonTag) {
    canonTag = document.createElement("link");
    canonTag.setAttribute("rel", "canonical");
    document.head.appendChild(canonTag);
  }
  canonTag.setAttribute("href", canonical);

  next();
});

export default router;
